import React, { useMemo } from 'react'
import { Form } from 'formik'
import { FormColumn, FormRow, TitleBar } from 'components/Shared/CrudComponents'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { useTranslation } from 'react-i18next'
import { createValidationSchema } from './form'
import { Loader } from 'components/Shared/Loader'
import { FormikForm } from 'components/Shared/FormikForm'
import Sections from 'components/FerryServices/sections'
import Module from 'constants/customFieldModules'
import {
  FERRY_SERVICE_ADDITIONAL_DATA_READ,
  FERRY_SERVICE_ADDITIONAL_DATA_WRITE,
  FERRY_SERVICE_CONTRACTOR_READ,
  FERRY_SERVICE_CONTRACTOR_WRITE,
  FERRY_SERVICE_DATA_READ,
  FERRY_SERVICE_DATA_WRITE,
  useAuth
} from 'context/auth'
import { CurrencySelectField } from 'components/Shared/CurrencySelectField'
import { ContractorSelectField } from '../../Carrier/CarrierSelectField'

export default function FerryServiceForm ({ initialValues, entityId, onSubmit, title, loading }) {
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  const validationSchema = useMemo(() => createValidationSchema(), [])

  return (
    <>
      {loading && <Loader/>}
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur
        enableReinitialize
        onSubmit={onSubmit}
        customFields={{
          module: Module.FerryServices,
          entityId: entityId
        }}>
        <Form>
          <TitleBar
            buttonLabel={t('ferryServices.form.submit')}
            buttonDisabled={loading}
            title={title}/>
          <FormRow>
            <FormColumn section={Sections.Contractor}
                        disabled={!hasAnyPrivileges([FERRY_SERVICE_CONTRACTOR_WRITE])}
                        visible={hasAnyPrivileges([FERRY_SERVICE_CONTRACTOR_READ])}>
              <ContractorSelectField
                fieldName="contractorId"
                label="ferryServices.form.fields.contractor"
              />
            </FormColumn>
            <FormColumn section={Sections.BasicDetails}
                        disabled={!hasAnyPrivileges([FERRY_SERVICE_DATA_WRITE])}
                        visible={hasAnyPrivileges([FERRY_SERVICE_DATA_READ])}>
              <FieldComponent
                fieldName="startLocation.text"
                label="ferryServices.form.fields.startLocation"
              />
              <FieldComponent
                fieldName="endLocation.text"
                label="ferryServices.form.fields.endLocation"
              />
              <FieldComponent
                fieldName="type"
                label="ferryServices.form.fields.type"
              />
              <FieldComponent
                fieldName="price"
                label="ferryServices.form.fields.price"
                type="number"/>
              <CurrencySelectField
                fieldName="currencyCode"
                label="ferryServices.form.fields.currencyCode"
              />
              <FieldComponent
                fieldName="bunkerAdjustmentFactor"
                label="ferryServices.form.fields.bunkerAdjustmentFactor"
                type="number"
              />
              <FieldComponent
                fieldName={`harbourLocation`}
                label="ferryServices.form.fields.harbourLocation"
              />
            </FormColumn>
            <FormColumn section={Sections.AdditionalData}
                        disabled={!hasAnyPrivileges([FERRY_SERVICE_ADDITIONAL_DATA_WRITE])}
                        visible={hasAnyPrivileges([FERRY_SERVICE_ADDITIONAL_DATA_READ])}>
              <FieldComponent
                fieldName="additionalInfo"
                label="ferryServices.form.fields.additionalInfo"
              />
            </FormColumn>
          </FormRow>
        </Form>
      </FormikForm>
    </>
  )
}
